<form novalidate #propertySaleDetailsSectionForm="ngForm">
    <tg-row *ngIf="draftLoaded$ | async">
        <tg-col md="8" sm="12">
            <tg-row>
                <tg-col sm="12">
                    <h2>How would you like to sell the property?</h2>
                </tg-col>
            </tg-row>
            <tg-row>
                <tg-col lg="4" md="6" sm="12">
                    <tg-select-container label="Type of sale">
                        <select
                            tgSelect
                            name="typeOfSale"
                            (change)="typeOfSaleChange()"
                            [(ngModel)]="
                                draftData.propertyInformation.propertyPriceType
                            "
                            [validation]="
                                validation.propertyInformation.propertyPriceType
                                    | toValidator: metadata.saleTypes
                            "
                        >
                            <option
                                *ngFor="let opt of metadata.saleTypes"
                                [ngValue]="opt.value"
                            >
                                {{ opt.display }}
                            </option>
                        </select>
                    </tg-select-container>
                </tg-col>
                <tg-col lg="4" md="6" sm="12" *ngIf="isTypeOfSalePrice()">
                    <tg-input-container
                        [label]="typeOfSaleInputLabel"
                        [description]="typeOfSaleInputDescription"
                    >
                        <span
                            class="
                                property-sale-details-section__currency-symbol
                            "
                            >$</span
                        >
                        <input
                            wholeNumber
                            tgTextInput
                            name="typeOfSalePrice"
                            (blur)="publish()"
                            (change)="
                                onTypeOfSalePriceChange($event.target.value)
                            "
                            [(ngModel)]="
                                draftData.propertyInformation.propertyPricePrice
                            "
                            [validation]="getTypeOfSaleValueValidation()"
                        />
                    </tg-input-container>
                </tg-col>
            </tg-row>
            <tg-row *ngIf="isTypeOfSaleDate()">
                <tg-col lg="4" md="6" sm="12"
                    ><tm-date
                        name="typeOfSaleDate"
                        [label]="typeOfSaleInputLabel"
                        inputReadonly
                        [minDate]="minDate"
                        [selectedDate]="
                            draftData.propertyInformation.propertyPriceDate
                        "
                        (dateChange)="onTypeOfSaleDateChange($event)"
                        [validation]="getTypeOfSaleValueValidation()"
                    ></tm-date
                ></tg-col>
                <tg-col lg="4" md="6" sm="12" *ngIf="isAuctionPriceType()">
                    <tg-select-container
                        label="Auction time"
                    >
                        <select
                            tgSelect
                            name="auctionTime"
                            (change)="auctionTimeChange()"
                            [(ngModel)]="draftData.propertyInformation.auctionTime"
                            [validation]="auctionTimeValidation()"
                        >
                            <option [ngValue]="0" selected></option>
                            <option
                                *ngFor="let o of metadata.auctionTimes"
                                [ngValue]="o.value"
                            >
                                {{ o.display }}
                            </option>
                        </select>
                    </tg-select-container>
                </tg-col>
            </tg-row>
            <tg-row>
                <tg-col
                    lg="4"
                    md="6"
                    sm="12"
                    class="property-sale-details-section__expected-sale-price"
                >
                    <tg-input-container
                        class="hide-optional-label"
                        label="Expected sale price"
                        description="Used for searches - not shown on site"
                    >
                        <span
                            class="
                                property-sale-details-section__currency-symbol
                            "
                            >$</span
                        >
                        <input
                            wholeNumber
                            tgTextInput
                            name="propertySalePrice"
                            size="large"
                            (blur)="publish()"
                            [(ngModel)]="
                                draftData.propertyInformation.propertySalePrice
                            "
                            [validation]="
                                validation.propertyInformation.propertySalePrice
                                    | toValidator
                            "
                        />
                    </tg-input-container>
                </tg-col>
            </tg-row>
            <tg-row>
                <tg-col
                    lg="4"
                    md="6"
                    sm="12"
                    class="property-sale-details-section__rv"
                >
                    <tg-input-container label="Capital value (CV)">
                        <span
                            class="
                                property-sale-details-section__currency-symbol
                            "
                            >$</span
                        >
                        <input
                            wholeNumber
                            tgTextInput
                            name="rateableValue"
                            size="large"
                            (blur)="publish()"
                            [(ngModel)]="
                                draftData.propertyInformation.rateableValue
                            "
                            [validation]="
                                validation.propertyInformation.rateableValue
                                    | toValidator
                            "
                        />
                    </tg-input-container>
                </tg-col>
            </tg-row>
            <tg-row *ngIf="isUntilWithdrawn">
                <tg-col md="4" sm="12">
                    <tg-label
                        class="property-sale-details-section__duration">
                        Listing duration
                    </tg-label>
                    <p class="p-secondary-copy">Until withdrawn</p>
                </tg-col>
            </tg-row>
            <tg-row *ngIf="!isUntilWithdrawn">
                <tg-col lg="4" md="6" sm="12">
                    <tg-label
                        *ngIf="hasBeenAnExtension"
                        class="property-sale-details-section__duration">
                        Listing duration
                    </tg-label>
                    <tg-select-container
                        *ngIf="!hasBeenAnExtension"
                        class="hide-optional-label"
                        label="Listing duration"
                    >
                        <select
                            tgSelect
                            name="duration"
                            ngModel
                            (change)="updateAvailableText(); publish()"
                            [(ngModel)]="draftData.propertyInformation.duration"
                            [validation]="
                                validation.propertyInformation.duration
                                    | toValidator
                            "
                        >
                            <option
                                *ngFor="let opt of durationOptions"
                                [ngValue]="opt.value"
                            >
                                {{ opt.display }}
                            </option>
                        </select>
                    </tg-select-container>
                </tg-col>
            </tg-row>
            <tg-row *ngIf="!isUntilWithdrawn">
                <tg-col>
                    <p class="p-secondary-copy">
                        Listing ends
                        {{
                            durationDate | tgDateTime: { format: 'long' }
                        }}.<br />
                        Relist for free within 45 days of ending - listing
                        upgrades do not carry over.
                    </p>
                </tg-col>
            </tg-row>
        </tg-col>
        <tg-col md="4" sm="12">
            <property-side-card
                class="property-sale-details-section__side-card"
                [icon]="sideCardIcon"
                [heading]="sideCardHeading"
                [callToActionText]="sideCardCallToActionText"
                [callToActionLink]="sideCardCallToActionLink"
            >
                {{ sideCardDescription }}
            </property-side-card>
        </tg-col>
    </tg-row>
</form>
